import { get } from "lodash";
import { navigateTo } from "./location";

export const getOrderHomePath = (pageContext) =>
  get(pageContext, "orderHomePath", "/");

export const navigateHome = (pageContext) =>
  navigateTo(getOrderHomePath(pageContext));
